export const instantInvoicing = [
  {
    path: '/instantInvoicing',
    name: 'instantInvoicing',
    component: () => import('@/views/instantInvoicing'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/instantInvoicing/detail',
    name: 'instantInvoicingDetail',
    component: () => import('@/views/instantInvoicing/detail'),
    meta: {
      title: '开票详情'
    }
  },
  {
    path: '/instantInvoicing/search',
    name: 'instantInvoicingSearch',
    component: () => import('@/views/instantInvoicing/search'),
    meta: {
      title: '搜索开票记录'
    }
  },
  {
    path: '/instantInvoicing/setting',
    name: 'instantInvoicingSetting',
    component: () => import('@/views/instantInvoicing/setting'),
    meta: {
      title: '开票设置'
    }
  },
  {
    path: '/instantInvoicing/setting/config',
    name: 'instantInvoicingConfig',
    component: () => import('@/views/instantInvoicing/setting/config'),
    meta: {
      title: '开票设置'
    }
  },
  {
    path: '/instantInvoicing/setting/store',
    name: 'instantInvoicingStore',
    component: () => import('@/views/instantInvoicing/setting/store'),
    meta: {
      title: '开票门店'
    }
  },
  {
    path: '/instantInvoicing/setting/device',
    name: 'instantInvoicingDevice',
    component: () => import('@/views/instantInvoicing/setting/device'),
    meta: {
      title: '收款设备设置'
    }
  }
]
